import React from "react";
import { CreateTableNew as CreateTable } from "../../../../../common/APICommon";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit'; // ADDED

const EmployeeTransactionApproverTable = ({
  data,
  onEdit, // ADDED
  onDelete,
  loading,
  currentPage,
  setCurrentPage
}) => {
  const headers = ["ID", "Employee No", "Full Name", "Actions"];
  const accessors = ["id", "employeeNo", "fullName", "actions"];

  const actions = [
    // ADDED: Edit action
    {
      name: "Edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600 flex items-center",
      function: (item) => onEdit(item),
      visible: true,
    },
    {
      name: "Remove",
      icon: <DeleteIcon fontSize="small" />,
      className: "bg-red-500 hover:bg-red-600 flex items-center",
      function: (item) => onDelete(item.id, item.fullName),
      visible: true,
    },
  ];

  return (
    <CreateTable
      tableName={"Approvers List"}
      headers={headers}
      accessors={accessors}
      data={data}
      actions={actions}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      itemsPerPage={10}
      totalItems={data?.length}
      loading={loading}
    />
  );
};

export default EmployeeTransactionApproverTable;